// Ortak kategori bandı satırı (Özet, Disclosure, Hedefler, portal Özet) — Katalog/Veri Girişi ile
// aynı görünüm dili (bandRowBg, depth girintisi 22/14 px). Aç/kapa düğmesi `aria-expanded` taşır;
// ←/→ bantta kapat/aç (CheckTree ile aynı tuşlar).
import { bandRowBg, hitArea44 } from "./kpi-form-styles";
import { KPI_COPY } from "../../lib/kpi-ui";
import { treeIndent, type TreeListRow } from "../../lib/kpi-tree-list";

type BandRow = Extract<TreeListRow<unknown>, { kind: "band" }>;

export function KpiTreeBandRow(props: {
  row: BandRow;
  colSpan: number;
  filtered: boolean;
  narrow: boolean;
  onToggle: (id: string, collapsed: boolean) => void;
}): JSX.Element {
  const { row, colSpan, filtered, narrow, onToggle } = props;
  const id = row.indicator.id;
  return (
    <tr data-band={row.indicator.code} data-depth={row.depth} style={{ background: bandRowBg }}>
      <td
        colSpan={colSpan}
        style={{
          padding: `2px 10px 2px ${10 + treeIndent(row.depth, narrow)}px`,
          borderBottom: "1px solid var(--color-border)",
          textAlign: "left",
        }}
      >
        <button
          type="button"
          aria-expanded={!row.collapsed}
          aria-label={KPI_COPY.tree.toggle(row.indicator.label, row.collapsed)}
          onClick={() => onToggle(id, !row.collapsed)}
          onKeyDown={(e) => {
            if (e.key === "ArrowLeft" && !row.collapsed) {
              e.preventDefault();
              onToggle(id, true);
            } else if (e.key === "ArrowRight" && row.collapsed) {
              e.preventDefault();
              onToggle(id, false);
            }
          }}
          style={{
            ...hitArea44,
            margin: 0,
            minHeight: 36,
            justifyContent: "flex-start",
            gap: 8,
            padding: "0 4px",
            fontWeight: 700,
            fontSize: "0.82rem",
            color: "var(--color-text)",
          }}
        >
          <span aria-hidden="true" style={{ width: 12, color: "var(--color-text-3)" }}>
            {row.collapsed ? "▸" : "▾"}
          </span>
          <span>{row.indicator.label}</span>
          <span
            data-testid="band-counter"
            style={{ fontWeight: 500, fontSize: "0.72rem", color: "var(--color-text-3)" }}
          >
            {KPI_COPY.tree.counter(row.matching, row.total, filtered)}
          </span>
        </button>
      </td>
    </tr>
  );
}

/** "Tümünü daralt / genişlet" başlık eylemi — yalnız ağaçta bant varsa render edilir. */
export function KpiTreeToolbar(props: {
  onCollapseAll: () => void;
  onExpandAll: () => void;
}): JSX.Element {
  const btn = {
    fontSize: "0.75rem",
    color: "var(--color-primary)",
    minHeight: 28,
    padding: "0 6px",
  } as const;
  return (
    <div
      role="group"
      aria-label={KPI_COPY.tree.toolbarLabel}
      className="flex justify-end gap-2 px-3 py-1"
    >
      <button type="button" style={btn} onClick={props.onCollapseAll}>
        {KPI_COPY.tree.collapseAll}
      </button>
      <button type="button" style={btn} onClick={props.onExpandAll}>
        {KPI_COPY.tree.expandAll}
      </button>
    </div>
  );
}
